module.exports = __webpack_public_path__ + "static/media/TirePressureMonitoringSystem.c2a10253.svg";